export const sidebarData = {
    accounting: [
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' },
        { id: 'overview', title: 'all.menu.overview', path: '/accounting', icon: 'home' },
        { id: 'journals', title: 'accounting.menu.journals', path: '/accounting/journal', icon: 'paper' },
        // A grid for keyboard entry — not offered on a phone.
        { id: 'fastJournals', title: 'accounting.menu.fastJournals', path: '/accounting/fast-journal', icon: 'generateList', desktopOnly: true },
        { id: 'balance', title: 'accounting.menu.balance', path: '/accounting/balance', icon: 'money' },
        { id: 'vatReturn', title: 'accounting.menu.vatReturn', path: '/accounting/vat-return', icon: 'money' },
        {
            id: 'setup',
            title: 'accounting.menu.setup', icon: 'gear',
            subNav: [
                { id: 'accounts', title: 'accounting.menu.accounts', path: '/accounting/account', icon: 'books' },
                { id: 'postingRules', title: 'accounting.menu.postingRules', path: '/accounting/posting-rule', icon: 'sliders' },
                { id: 'periods', title: 'accounting.menu.periods', path: '/accounting/period', icon: 'lock' }
            ]
        },
        {
            id: 'administration',
            title: 'accounting.menu.administration', icon: 'gear',
            subNav: [
                { id: 'transactions', title: 'accounting.menu.transactions', path: '/accounting/ledger', icon: 'generateList' },
                { id: 'postingStatus', title: 'accounting.menu.postingStatus', path: '/accounting/posting-status', icon: 'generateList' }
            ]
        },
        { id: 'settings', title: 'accounting.menu.settings', path: '/accounting/settings', icon: 'gear' }
    ],
    admin: [
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' },
        { id: 'employees', title: 'admin.menu.employees', path: '/admin/employee', icon: 'people' },
        { id: 'organizations', title: 'admin.menu.organizations', path: '/admin/organization', icon: 'org' },
        { id: 'users', title: 'admin.menu.users', path: '/admin/user', icon: 'people' },
        { id: 'portals', title: 'admin.menu.portals', path: '/admin/portals', icon: 'peopleGroup' },
        {
            id: 'periodic',
            title: 'admin.menu.periodic', icon: 'planner',
            subNav: [
                { id: 'stats', title: 'admin.menu.stats', path: '/admin/stats', icon: 'sync' }
            ]
        },
        { id: 'settings', title: 'admin.menu.settings', path: '/admin/settings', icon: 'gear' }
    ],
    bank: [
        {
            id: 'toAllApps',
            title: 'all.menu.backHome',
            path: '/home',
            icon: 'back'
        },
        {
            id: 'overview',
            title: 'all.menu.overview',
            path: '/bank',
            icon: 'home'
        },
        {
            id: 'accounts',
            title: 'bank.menu.accounts',
            path: '/bank/account',
            icon: 'bank'
        }],
    crm: [
        {
            id: 'toAllApps',
            title: 'all.menu.backHome',
            path: '/home',
            icon: 'back'
        },
        {
            id: 'overview',
            title: 'all.menu.overview',
            path: '/crm',
            icon: 'home'
        },
        {
            id: 'contacts',
            title: 'all.menu.contacts',
            path: 'crm/contact',
            icon: 'people',
        },
        {
            id: 'campaigns',
            title: 'crm.menu.campaign',
            path: 'crm/campaign',
            icon: 'megaphone',
        },
        {
            id: 'customerGroups',
            title: 'crm.menu.customer.group',
            path: 'crm/customerGroup',
            icon: 'peopleGroup',
        },
        {
            id: 'service',
            title: 'crm.menu.service',
            path: '/service',
            icon: 'help',
            fastNav: false,
        },

    ],
    documents: [
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' },
        { id: 'overview', title: 'all.menu.overview', path: '/documents', icon: 'home' },
        { id: 'browse', title: 'documents.menu.browser', path: '/documents/browser', icon: 'folder' },
        { id: 'allDocuments', title: 'documents.menu.allDocuments', path: '/documents/document', icon: 'document' },
        {
            id: 'manage',
            title: 'documents.menu.manage', icon: 'gear',
            subNav: [
                { id: 'folders', title: 'documents.menu.folders', path: '/documents/folder', icon: 'folder' }
            ]
        }
    ],
    customerPortal: [
        { id: 'invoices', title: 'portal.nav.invoices', path: 'invoice', icon: 'invoice' },
        { id: 'creditNotes', title: 'portal.nav.creditNotes', path: 'creditNote', icon: 'creditNote' }
    ],
    hello: [
        {
            id: 'allYourApps',
            title: 'hello.menu01',
            path: '/home',
            icon: 'home'
        },
        {
            id: 'cRMApp',
            title: 'hello.menu02',
            path: '/crm',
            icon: 'people'
        }

    ],
    home: [
        {
            id: 'apps',
            title: 'home.menu.apps',
            icon: 'apps',
            path: '/home/apps'
        },
        {
            id: 'settings',
            title: 'home.menu.settings',
            icon: 'gear',
            path: '/home/settings'
        }
    ],
    inventory: [
        {
            id: 'toAllApps',
            title: 'all.menu.backHome',
            path: '/home',
            icon: 'back'
        },
        {
            id: 'overview',
            title: 'all.menu.overview',
            path: '/inventory',
            icon: 'home'
        },
        {
            id: 'products',
            title: 'inventory.menu.products',
            path: '/inventory/product',
            icon: 'boxes'
        },
        {
            id: 'documents',
            title: 'all.menu.documents',
            icon: 'paper',
            subNav: [
                {
                    id: 'shipments',
                    title: 'inventory.menu.shipments',
                    path: 'inventory/shipment',
                    icon: 'shipment',
                },
                {
                    id: 'receipts',
                    title: 'inventory.menu.receipts',
                    path: 'inventory/receipt',
                    icon: 'receipt'
                },
                {
                    id: 'adjustments',
                    title: 'inventory.menu.adjustments',
                    path: '/inventory/adjustment',
                    icon: 'stockAdjustment'
                },
                {
                    id: 'movements',
                    title: 'inventory.menu.movements',
                    path: '/inventory/movement',
                    icon: 'stockMovement'
                }
            ]
        },
        {
            id: 'locations',
            title: 'inventory.menu.locations',
            icon: 'location',
            subNav: [
                {
                    id: 'warehouses',
                    title: 'inventory.menu.warehouses',
                    path: 'inventory/warehouse',
                    icon: 'warehouse',
                },
                {
                    id: 'racks',
                    title: 'inventory.menu.racks',
                    path: 'inventory/rack',
                    icon: 'rack'
                },
                {
                    id: 'bins',
                    title: 'inventory.menu.bins',
                    path: 'inventory/location',
                    icon: 'pallet'
                }
            ]
        },
        {
            id: 'productSetup',
            title: 'inventory.menu.productSetup',
            icon: 'productGroup',
            subNav: [
                {
                    id: 'productFamilies',
                    title: 'inventory.menu.productFamilies',
                    path: '/inventory/productFamily',
                    icon: 'boxes'
                },
                {
                    id: 'productGroups',
                    title: 'inventory.menu.productGroups',
                    path: 'inventory/productGroup',
                    icon: 'productGroup'
                }
            ]
        },
        {
            id: 'administration',
            title: 'inventory.menu.administration',
            icon: 'gear',
            subNav: [
                {
                    id: 'ledger',
                    title: 'inventory.menu.ledger',
                    path: '/inventory/ledger',
                    icon: 'boxes'
                },
                {
                    id: 'audit',
                    title: 'inventory.menu.audit',
                    path: '/inventory/audit',
                    icon: 'checkMark'
                }
            ]
        },
        {
            id: 'settings',
            title: 'inventory.menu.settings',
            path: 'inventory/settings',
            icon: 'gear',
        }
    ],
    invitation: [
        { id: 'acceptInvitation', title: 'portal.nav.accept', path: 'accept', icon: 'people' }
    ],
    joinOrganization: [],
    manufacturing: [
        {
            id: 'toAllApps',
            title: 'all.menu.backHome',
            path: '/home',
            icon: 'back'
        },
        {
            id: 'overview',
            title: 'all.menu.overview',
            path: '/manufacturing',
            icon: 'home'
        },
        {
            id: 'workOrders',
            title: 'manufacturing.menu.workOrders',
            path: '/manufacturing/workOrder',
            icon: 'task'
        },
        {
            id: 'queue',
            title: 'workExecution.menu.queue',
            path: '/manufacturing/queue',
            icon: 'play'
        },
        {
            id: 'planning',
            title: 'manufacturing.menu.planning',
            path: '/manufacturing/planning',
            icon: 'planner'
        },
        {
            id: 'routingVersions',
            title: 'manufacturing.menu.routingVersions',
            path: '/manufacturing/routingVersion',
            icon: 'sliders'
        },
        {
            id: 'qualityControl',
            title: 'manufacturing.menu.qualityChecks',
            path: '/manufacturing/qualityCheck',
            icon: 'checkMark'
        },
        {
            id: 'equipment',
            title: 'manufacturing.menu.equipment',
            icon: 'factory',
            subNav: [
                {
                    id: 'plants',
                    title: 'manufacturing.menu.plants',
                    path: '/manufacturing/plant',
                    icon: 'factory'
                },
                {
                    id: 'workDepartments',
                    title: 'manufacturing.menu.workDepartments',
                    path: '/manufacturing/workDepartment',
                    icon: 'people'
                },
                {
                    id: 'workCenters',
                    title: 'manufacturing.menu.workCenters',
                    path: '/manufacturing/workCenter',
                    icon: 'warehouse'
                },
                {
                    id: 'machines',
                    title: 'manufacturing.menu.machines',
                    path: '/manufacturing/machine',
                    icon: 'gear'
                },
                {
                    id: 'workCapabilities',
                    title: 'manufacturing.menu.workCapability',
                    path: '/manufacturing/workCapability',
                    icon: 'sliders'
                }
            ]
        },
        {
            id: 'settings',
            title: 'manufacturing.menu.settings',
            icon: 'gear',
            subNav: [
                {
                    id: 'generalSettings',
                    title: 'manufacturing.menu.settingsOverview',
                    path: '/manufacturing/settings',
                    icon: 'gear'
                },
                {
                    id: 'shifts',
                    title: 'manufacturing.menu.shifts',
                    path: '/manufacturing/shift',
                    icon: 'sliders'
                }
            ]
        }
    ],
    project: [
        {
            id: 'toAllApps',
            title: 'all.menu.backHome',
            path: '/home',
            icon: 'back'
        },
        {
            id: 'overview',
            title: 'all.menu.overview',
            path: '/project',
            icon: 'home'
        },
        {
            id: 'projects',
            title: 'project.menu.projects',
            path: '/project/project',
            icon: 'task'
        },
        {
            id: 'taskBoard',
            title: 'project.menu.kanban',
            path: '/project/kanban',
            icon: 'kanban'
        },
        {
            id: 'team',
            title: 'project.menu.team',
            path: '/project/team',
            icon: 'people'
        },
        {
            id: 'settings',
            title: 'project.menu.settings',
            path: '/project/settings',
            icon: 'gear'
        }
    ],
    purchases: [
        {
            id: 'toAllApps',
            title: 'all.menu.backHome',
            path: '/home',
            icon: 'back'
        },
        {
            id: 'overview',
            title: 'all.menu.overview',
            path: '/purchases',
            icon: 'home'
        },
        // Receipts and invoices dropped here become expenses (task 38.04).
        {
            id: 'inbox',
            title: 'purchases.menu.inbox',
            path: '/purchases/inbox',
            icon: 'inbox'
        },
        {
            id: 'documents',
            title: 'all.menu.documents',
            icon: 'paper',
            subNav: [
                {
                    id: 'purchaseRequests',
                    title: 'purchases.menu.purchaseRequests',
                    path: 'purchases/purchaseRequest',
                    icon: 'invoice'
                },
                {
                    id: 'purchaseOrders',
                    title: 'purchases.menu.purchaseOrders',
                    path: 'purchases/purchaseOrder',
                    icon: 'invoice'
                },
                {
                    id: 'expenses',
                    title: 'purchases.menu.expenses',
                    path: 'purchases/expense',
                    icon: 'invoice'
                }
            ]
        },
        {
            id: 'suppliers',
            title: 'purchases.menu.contacts',
            path: '/purchases/contact',
            icon: 'contacts'
        },
        {
            id: 'settings',
            title: 'purchases.menu.settings',
            path: 'purchases/settings',
            icon: 'gear'
        }
    ],
    resetPassword: [],
    sales: [
        {
            id: 'toAllApps',
            title: 'all.menu.backHome',
            path: '/home',
            icon: 'back'
        },
        {
            id: 'overview',
            title: 'all.menu.overview',
            path: '/sales',
            icon: 'home'
        },
        {
            id: 'documents',
            title: 'sales.menu.documents',
            icon: 'paper',
            subNav: [
                {
                    id: 'salesQuotes',
                    title: 'sales.menu.quotes',
                    path: 'sales/quote',
                    icon: 'quote'
                },
                {
                    id: 'invoices',
                    title: 'sales.menu.invoices',
                    path: 'sales/invoice',
                    icon: 'invoice',
                },
                {
                    id: 'creditNotes',
                    title: 'sales.menu.creditNotes',
                    path: 'sales/creditNote',
                    icon: 'creditNote'
                }
            ]
        },
        {
            id: 'contacts',
            title: 'sales.menu.contacts',
            path: 'sales/contact',
            icon: 'contacts',
        },
        {
            id: 'products',
            title: 'sales.menu.products',
            path: 'sales/product',
            icon: 'boxes',
        },
        {
            id: 'priceLists',
            title: 'sales.menu.priceLists',
            path: 'sales/priceList',
            icon: 'price',
        },
        {
            id: 'settings',
            title: 'sales.menu.settings',
            path: 'sales/settings',
            icon: 'gear',
        },
    ],
    service: [
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' },
        { id: 'overview', title: 'all.menu.overview', path: '/service', icon: 'home' },
        { id: 'planning', title: 'service.menu.planning', path: '/service/planning', icon: 'planner' },
        {
            id: 'operations',
            title: 'service.menu.operations',
            icon: 'task',
            subNav: [
                { id: 'tickets', title: 'service.menu.tickets', path: '/service/serviceTicket', icon: 'help' },
                { id: 'workOrders', title: 'service.menu.workOrders', path: '/service/serviceWorkOrder', icon: 'task' }
            ]
        },
        {
            id: 'registry',
            title: 'service.menu.registry',
            icon: 'factory',
            subNav: [
                { id: 'assets', title: 'service.menu.assets', path: '/service/asset', icon: 'factory' },
                { id: 'locations', title: 'service.menu.locations', path: '/service/serviceLocation', icon: 'location' }
            ]
        },
        {
            id: 'commercial',
            title: 'service.menu.commercial',
            icon: 'paper',
            subNav: [
                { id: 'contracts', title: 'service.menu.contracts', path: '/service/serviceContract', icon: 'paper' }
            ]
        },
        {
            id: 'setup',
            title: 'service.menu.setup',
            icon: 'sliders',
            subNav: [
                { id: 'serviceTypes', title: 'service.menu.serviceTypes', path: '/service/serviceType', icon: 'sliders' },
                { id: 'serviceSkills', title: 'service.menu.serviceSkills', path: '/service/serviceSkill', icon: 'sliders' },
                { id: 'serviceWorkers', title: 'service.menu.serviceWorkers', path: '/service/serviceWorker', icon: 'people' },
                { id: 'technicians', title: 'service.menu.serviceTechnicians', path: '/service/serviceTechnician', icon: 'peopleGroup' }
            ]
        },
        {
            id: 'settings',
            title: 'service.menu.settings',
            icon: 'gear',
            subNav: [
                { id: 'settings', title: 'service.menu.settingsOverview', path: '/service/settings', icon: 'gear' }
            ]
        }
    ],
    // Studio (30.03.08): where an owner shapes the org's model. Denied to overlays
    // (customization/policy.js), so no customization can hide the screen that undoes it.
    studio: [
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' },
        { id: 'overview', title: 'studio.menu.overview', path: '/studio', icon: 'home' },
        { id: 'fields', title: 'studio.menu.fields', path: '/studio/field', icon: 'plus' },
        { id: 'overlays', title: 'studio.menu.overlays', path: '/studio/overlay', icon: 'sliders' },
        { id: 'versions', title: 'studio.menu.versions', path: '/studio/version', icon: 'sync' }
    ],
    supplierPortal: [
        { id: 'orders', title: 'portal.nav.orders', path: 'orders', icon: 'receipt' }
    ],
    warehouse: [
        { id: 'toAllApps', title: 'all.menu.backHome', path: '/home', icon: 'back' },
        { id: 'overview', title: 'all.menu.overview', path: '/warehouse', icon: 'home' },
        {
            id: 'orders',
            title: 'warehouse.menu.orders', icon: 'paper',
            subNav: [
                { id: 'releasedOrders', title: 'warehouse.menu.open', path: '/warehouse/warehouseOrder/released', icon: 'task' },
                { id: 'allOrders', title: 'warehouse.menu.all', path: '/warehouse/warehouseOrder', icon: 'paper' },
            ]
        },
        { id: 'sitesMap', title: 'warehouse.menu.sitesMap', path: '/warehouse/site', icon: 'world' },
        { id: 'warehouseLayout', title: 'warehouse.menu.layout', path: '/warehouse/layout', icon: 'design' },
        { id: 'settings', title: 'warehouse.menu.settings', path: '/warehouse/settings', icon: 'gear' },
    ]
}
